import React from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function GoogleAuthCallback() {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const processed = React.useRef(false);

    React.useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const error = params.get("error");

        (async () => {
            if (error) {
                toast.error("Autentificare Google anulată.");
                window.history.replaceState(null, "", "/cont");
                navigate("/login", { replace: true });
                return;
            }
            if (!code) {
                navigate("/login", { replace: true });
                return;
            }
            try {
                const res = await api.post("/auth/google/callback", { code });
                if (res.data.token) {
                    localStorage.setItem("st_token", res.data.token);
                }
                // Clean URL before checkAuth so the code isn't reused
                window.history.replaceState(null, "", "/cont");
                await checkAuth();
                toast.success("Autentificat cu Google!");
                navigate("/cont", { replace: true });
            } catch (err) {
                const msg = err.response?.data?.detail || "Eroare la autentificare Google";
                toast.error(msg);
                window.history.replaceState(null, "", "/cont");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, checkAuth]);

    return (
        <div className="min-h-screen flex items-center justify-center font-mono text-muted-foreground">
            Autentificare Google în curs...
        </div>
    );
}
